import { render, staticRenderFns } from "./VideoPlayerWrapper.vue?vue&type=template&id=433a2f80&scoped=true"
import script from "./VideoPlayerWrapper.vue?vue&type=script&lang=ts&setup=true"
export * from "./VideoPlayerWrapper.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./VideoPlayerWrapper.vue?vue&type=style&index=0&id=433a2f80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433a2f80",
  null
  
)

export default component.exports